const state = {
  snack: {
    message: '',
    type: '',
    timeout: 2000
  }
}

const actions = {
  setSnack ({commit}, snack) {
    commit('setSnack', snack)
  }
}

const mutations = {
  setSnack (state, snack) {
    state.snack.message = snack.message
    state.snack.type = snack.type
    state.snack.timeout = snack.timeout || 2000
  }
}

export default {
  namespaced: true,
  actions,
  state,
  mutations
}
